import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const BalloonFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M20.48 14.78C20.48 16.5 19.24 17.74 17.52 17.74H16V21.54L11.08 17.74H6.48C4.76 17.74 3.52 16.5 3.52 14.78V8.34C3.52 6.62 4.76 5.38 6.48 5.38H17.52C19.24 5.38 20.48 6.62 20.48 8.34V14.78Z" />
    </SvgIcon>
  );
});
